/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleUpdate
 */
export interface ScheduleUpdate {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof ScheduleUpdate
     */
    variables?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {number}
     * @memberof ScheduleUpdate
     */
    type?: ScheduleUpdateTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleUpdate
     */
    enabled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleUpdate
     */
    lastRun?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ScheduleUpdate
     */
    every?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleUpdate
     */
    period?: ScheduleUpdatePeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleUpdate
     */
    crontabDayOfMonth?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleUpdate
     */
    crontabDayOfWeek?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleUpdate
     */
    crontabHour?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleUpdate
     */
    crontabMinute?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleUpdate
     */
    crontabMonthOfYear?: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduleUpdate
     */
    job: number;
}

/**
* @export
* @enum {string}
*/
export enum ScheduleUpdateTypeEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2
}/**
* @export
* @enum {string}
*/
export enum ScheduleUpdatePeriodEnum {
    Minutes = 'minutes',
    Hours = 'hours',
    Days = 'days'
}

export function ScheduleUpdateFromJSON(json: any): ScheduleUpdate {
    return ScheduleUpdateFromJSONTyped(json, false);
}

export function ScheduleUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'variables': !exists(json, 'variables') ? undefined : json['variables'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'lastRun': !exists(json, 'last_run') ? undefined : (json['last_run'] === null ? null : new Date(json['last_run'])),
        'every': !exists(json, 'every') ? undefined : json['every'],
        'period': !exists(json, 'period') ? undefined : json['period'],
        'crontabDayOfMonth': !exists(json, 'crontab_day_of_month') ? undefined : json['crontab_day_of_month'],
        'crontabDayOfWeek': !exists(json, 'crontab_day_of_week') ? undefined : json['crontab_day_of_week'],
        'crontabHour': !exists(json, 'crontab_hour') ? undefined : json['crontab_hour'],
        'crontabMinute': !exists(json, 'crontab_minute') ? undefined : json['crontab_minute'],
        'crontabMonthOfYear': !exists(json, 'crontab_month_of_year') ? undefined : json['crontab_month_of_year'],
        'job': json['job'],
    };
}

export function ScheduleUpdateToJSON(value?: ScheduleUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'variables': value.variables,
        'type': value.type,
        'enabled': value.enabled,
        'last_run': value.lastRun === undefined ? undefined : (value.lastRun === null ? null : value.lastRun.toISOString()),
        'every': value.every,
        'period': value.period,
        'crontab_day_of_month': value.crontabDayOfMonth,
        'crontab_day_of_week': value.crontabDayOfWeek,
        'crontab_hour': value.crontabHour,
        'crontab_minute': value.crontabMinute,
        'crontab_month_of_year': value.crontabMonthOfYear,
        'job': value.job,
    };
}


